<div class="deviation-report-container">
  <!-- Header -->
  <div class="report-header">
    <div class="header-left">
      <h1 class="report-title">BOQ Bidding Deviation Report</h1>
      <p class="report-subtitle" *ngIf="data?.invitation">
        {{ data.invitation.project_name }} | {{ data.invitation.boq_code }} - {{ data.invitation.boq_name }}
      </p>
    </div>
    <div class="header-right">
      <app-back-button
        label="Back to View All Bids"
        [link]="backLink"
        class="back-btn">
      </app-back-button>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading-container" *ngIf="loading">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading deviation report...</p>
  </div>

  <!-- Content -->
  <div *ngIf="!loading && data" class="content-wrapper">
    <div *ngIf="data.summary" class="summary-card">
      <p class="summary-text">Total deviations: <strong>{{ data.summary.total_deviations }}</strong></p>
      <p *ngIf="data.summary.by_bidder" class="summary-by-bidder">
        <ng-container *ngFor="let entry of data.summary.by_bidder | keyvalue">{{ entry.key }}: {{ entry.value }}; </ng-container>
      </p>
    </div>

    <div *ngIf="!data?.deviations?.length" class="empty-state">
      <mat-icon class="empty-icon">check_circle</mat-icon>
      <p>No deviations - all bidder quantities and rates match the estimated BOQ</p>
    </div>

    <div *ngIf="data?.deviations?.length" class="table-card">
      <div class="overflow-x-auto">
        <table class="deviation-table">
          <thead>
            <tr>
              <th class="text-left">Item</th>
              <th class="text-right">Est. Qty</th>
              <th class="text-right">Est. Rate</th>
              <th class="text-right">Bid Qty</th>
              <th class="text-right">Bid Rate</th>
              <th class="text-right">Deviation</th>
              <th class="text-left">Bidder</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of data.deviations" class="border-b hover:bg-gray-50">
              <td class="py-2 px-2">{{ d.item_description }}</td>
              <td class="py-2 px-2 text-right">{{ d.estimated_quantity }}</td>
              <td class="py-2 px-2 text-right">{{ formatCurrency(d.estimated_unit_rate) }}</td>
              <td class="py-2 px-2 text-right">{{ d.bidder_quantity }}</td>
              <td class="py-2 px-2 text-right">{{ formatCurrency(d.bidder_unit_rate) }}</td>
              <td class="py-2 px-2 text-right">
                <span class="inline-flex items-center gap-1" [ngClass]="getDeviationClass(getDeviationAmount(d))">
                  <mat-icon *ngIf="getDeviationAmount(d) > 0" class="text-base align-middle">arrow_downward</mat-icon>
                  <mat-icon *ngIf="getDeviationAmount(d) < 0" class="text-base align-middle">arrow_upward</mat-icon>
                  {{ formatCurrency(getDeviationAmount(d)) }}
                </span>
              </td>
              <td class="py-2 px-2">{{ d.bidder_org_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
